import { Grid } from '@mui/material';
import { Location } from '@nx-smartmonkey/shared/domain';
import { HSpacer } from '@nx-smartmonkey/ui';
import _ from 'lodash';

import CrossIcon from '../../assets/svg/CrossIcon';
import InputLocation from '../../react-components/InputLocation';
import InputText from '../../react-components/InputText';

interface StopsFromScratchDialogProps {
  stops: NewStopData[];
  setStops: (stops: NewStopData[]) => void;
}

type NewStopData = {
  label: string;
  location?: Location;
};

export const StopsFromScratch = ({ stops, setStops }: StopsFromScratchDialogProps) => {
  return (
    <Grid container direction="column" wrap="nowrap" style={{ overflowY: `auto`, height: `356px` }}>
      {_.range(stops.length + 1).map((index: number) => {
        return (
          <Grid
            item
            container
            direction="row"
            wrap="nowrap"
            key={`service-${index}`}
            alignItems="center"
            style={{ marginBottom: `8px` }}
          >
            <Grid item container>
              <InputText
                fullWidth
                tabIndex={index * 2}
                size="medium"
                bGColor="white"
                autoFocus={index === 0}
                variant="outlined"
                placeholderIntlId="plans.dialogs.services_from_scratch.label.placeholder"
                fieldValue={stops[index]?.label}
                onChange={(val: string) => {
                  const newStops = [...stops];
                  if (index >= stops.length) {
                    newStops.push({ label: val });
                  } else {
                    newStops[index].label = val;
                  }
                  setStops(newStops);
                }}
              />
            </Grid>

            <HSpacer large />

            <Grid item container>
              <InputLocation
                fullWidth
                inputProps={{
                  tabIndex: index * 2 + 1,
                  styles: {},
                  size: `medium`,
                  variant: `outlined`,
                  placeholderIntlId: `location`,
                }}
                emptyIntlId="no_results"
                fieldValue={stops[index]?.location}
                onUpdate={(location?: Location | null) => {
                  const newStops = [...stops];
                  if (index >= stops.length) {
                    newStops.push({ label: ``, location: location ?? undefined });
                  } else {
                    newStops[index].location = location ?? undefined;
                  }
                  setStops(newStops);
                }}
              />
            </Grid>

            <Grid item style={{ width: `24px`, cursor: `pointer` }}>
              {index < stops.length ? (
                <CrossIcon
                  style={{
                    color: `#D2190B`,
                    fontSize: `14px`,
                    marginLeft: `8px`,
                  }}
                  onClick={() => {
                    setStops(stops.filter((s: NewStopData, idx: number) => idx !== index));
                  }}
                />
              ) : (
                <div style={{ width: `22px` }} />
              )}
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};
